import { LOCAL_STORAGE_NAMES } from '../constants/constants';

export const saveExpiryTime = (expirationTime: number): void => {
  const absoluteExpiry = Date.now() + expirationTime;
  localStorage.setItem(LOCAL_STORAGE_NAMES.officeAddinTokenExpiry, absoluteExpiry.toString());
};

export const getExpiryTime = (): number | null => {
  const value = localStorage.getItem(LOCAL_STORAGE_NAMES.officeAddinTokenExpiry);
  return value ? Number.parseInt(value, 10) : null;
};
export const isTokenExpired = (): boolean => {
  const expiryTime = getExpiryTime();
  if (!expiryTime) return true;
  return Date.now() >= expiryTime;
};
export const clearExpiryTime = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_NAMES.officeAddinTokenExpiry);
};
